import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Topbar } from "@components";
import { PUBLIC_ROUTE } from "@router/route.constants";
import {
  LightText,
  SpinWrapper,
  Table,
  TableCell,
  TableHeading,
  TableHeadingCell,
  TableRow,
  RootContainer,
  EmptyText,
} from "./History.style";
import { LIMITS } from "@constants";
import { api } from "@api";
import { Spin, message } from "antd";
import moment from "moment";
import { getFormattedNumber } from "@utils";
import InfiniteScroll from "react-infinite-scroll-component";
import { useTranslation } from "react-i18next";

const { DEFAULT_PAGE, PAGE_SIZE } = LIMITS;

const History = () => {
  const { t } = useTranslation()
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(DEFAULT_PAGE);
  const [dataLength, setDataLength] = useState(0);

  const getHistory = useCallback(() => {
    setLoading(true);
    api
      .getSpinHistory({
        page,
        limit: PAGE_SIZE,
      })
      .then(({ spin_history, pagination }) => {
        setLoading(false);
        setDataLength(pagination.total);
        setData((prev) => [...prev, ...spin_history]);
      })
      .catch((errorMsg) => message.error(errorMsg));

  }, [page]);

  useEffect(() => {
    getHistory();
  }, [getHistory]);

  const goBack = () => {
    navigate(`/${PUBLIC_ROUTE.SPIN_HOME}`);
  };

  return (
    <RootContainer>
      <Topbar title={t("spin.historyTitle")} goBack={goBack} />
      <InfiniteScroll
        dataLength={data.length}
        next={() => {
          setPage((prev) => prev + 1);
        }}
        hasMore={loading || data.length !== dataLength}
        loader={
          <SpinWrapper>
            <Spin size="small" />
          </SpinWrapper>
        }
        endMessage={!loading && data.length === 0 && <EmptyText>{t("common.noRecord")}</EmptyText>}
      >
        <Table>
          {!loading && data.length > 0 &&
            <TableHeading>
              <TableHeadingCell>{t("common.date")}</TableHeadingCell>
              <TableHeadingCell>{t("spin.dailySpinTableHeadingAmount")}</TableHeadingCell>
            </TableHeading>
          }
          {data.map((history, index) => (
            <TableRow key={index}>
              <TableCell>
                {moment.unix(history.created_at).format("MMM DD, YYYY")}
                <LightText>
                  {moment.unix(history.created_at).format("hh:mm:ss A")}
                </LightText>
              </TableCell>
              <TableCell>{history.amount === 0 ? 'Thank you' : getFormattedNumber(history.amount)}</TableCell>
            </TableRow>
          ))}
        </Table>
      </InfiniteScroll>
    </RootContainer>
  );
};

export default History;
